import React, { Component } from 'react';
import classNames from 'classnames';

import LoadMask from 'Utils/LoadMask/LoadMask';
import Form from './InstitutionForm';

export default class InstitutionCrear extends Component {
    state = {
        editar: false,
        mensaje: 'Agregar Institucion',
        password: false,
    }

    componentWillMount() {
        if (this.props.match.params.id) {
            this.props.detail(this.props.match.params.id);
            this.setState({
                editar: true,
                mensaje: 'Editar Institucion',
            });
        }
    }

    render() {
        const {
            create,
            update,
            cargando,
            updateData,
            isNavBarOpen,
        } = this.props;

        const {editar} = this.state;

        return (
            <div className={classNames('content', { 'content-min': isNavBarOpen })}>
                <div className="m-auto row-fluid card-form">
                    <div className="table-decoration">
                        <LoadMask loading={cargando} blur_1>
                            {editar ? (
                                <div className="fields">
                                    <div className="top-title">
                                        INSTITUCION
                                    </div>
                                    <Form
                                        onSubmit={update}
                                        updateData={updateData}
                                        editando
                                    />
                                </div>
                            ) : (
                                <div className="fields">
                                    <div className="top-title">
                                        CREAR INSTITUCION
                                    </div>
                                    <Form onSubmit={create} />
                                </div>
                            )}
                        </LoadMask>
                    </div>
                </div>
            </div>
        );
    }
}
